import generateBodyForward from '@/mixin/generateBodyForward'
import findEmails from '@/mixin/findEmails'

export default {
  mixins: [generateBodyForward, findEmails],
  computed: {
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    activeEmail: {
      get: function () {
        return this.$store.getters.activeEmail
      },
      set: function (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    headers () {
      const { messages = [] } = this.activeEmail
      const [firstMessage] = messages
      const { payload = {} } = firstMessage
      const { headers = [] } = payload
      return headers
    },
    allAddresses () {
      const allAddresses = {
        toEmail: [],
        copy: []
      }

      const to = this.headers.find((el) => el.name === 'To')
      const cc = this.headers.find((el) => el.name === 'Cc')

      if (cc) allAddresses.copy = this.findEmails(cc.value)
      allAddresses.toEmail = this.findEmails(to.value)

      const { toEmail, copy } = allAddresses
      return {
        ...allAddresses,
        display: [...toEmail, ...copy].length > 1
      }
    }
  },
  methods: {
    createBodyForward () {
      const body = this.generateBodyForward(this.activeEmail, 'Fwd:')
      const { toEmail, copy } = this.allAddresses
      this.newMessage.open = false
      this.newMessage.isForward = true
      this.newMessage.isHideMailingList = true
      this.newMessage.toEmail = toEmail
      this.newMessage.copy = copy
      this.newMessage.subject = body.subject
      this.newMessage.contents = body.contentsHTML
      this.newMessage.attachmentsInset = body.attachmentsInset
      const files = body.attachments.map(item => {
        item.status = true
        return item
      })
      this.newMessage.files = files
      this.$set(this.newMessage, 'openFullSize', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/allAddresses.js